import { ACTION } from './floor_actions';
import {
  list_reducer,
  add_reducer,
  update_reducer,
  delete_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  isLoading: false,
  isEditing: false,
  isCreating: false,
  isDeleting: false,
  isDuplicating: false,
  isAddingToProject: false,
  isRemovingFromProject: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isLoading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        isEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isEditing: false,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isCreating: false,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DUPLICATE}_PENDING`:
      return {
        ...state,
        isDuplicating: true,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isDuplicating: false,
      };
    case `${ACTION.DUPLICATE}_REJECTED`:
      return {
        ...state,
        isDuplicating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isDeleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.ADD_FLOOR_TO_PROJECT}_PENDING`:
      return {
        ...state,
        isAddingToProject: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_FLOOR_TO_PROJECT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        orderedIds: [action.payload.id, ...state.orderedIds],
        isAddingToProject: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_FLOOR_TO_PROJECT}_REJECTED`:
      return {
        ...state,
        isAddingToProject: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REMOVE_FLOOR_FROM_PROJECT}_PENDING`:
      return {
        ...state,
        isRemovingFromProject: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_FLOOR_FROM_PROJECT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        orderedIds: state.orderedIds.filter(id => id !== action.payload.id),
        isRemovingFromProject: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_FLOOR_FROM_PROJECT}_REJECTED`:
      return {
        ...state,
        isRemovingFromProject: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/floor/floor_reducer.js